"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmbeddedContentAssetProperty = exports.embeddedContentAssetPropertyDefinition = void 0;
exports.embeddedContentAssetPropertyDefinition = {
    view: { label: 'Related assets' },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'artist',
                'athlete',
                'episode-video',
                'event-profile',
                'event-series',
                'film',
                'image',
                'image-gallery',
                'judge',
                'live-video',
                'occasion-campaign',
                'photographer',
                'podcast-episode',
                'podcast-show',
                'project-profile',
                'recap-video',
                'results-and-standings',
                'show',
                'story',
                'team',
                'trailer-video',
                'video',
                'video-vr-360',
            ],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'embedded-content-asset',
};
const isEmbeddedContentAssetProperty = (prop) => {
    return prop.name === exports.embeddedContentAssetPropertyDefinition.name;
};
exports.isEmbeddedContentAssetProperty = isEmbeddedContentAssetProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1iZWRkZWQtY29udGVudC1hc3NldC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2VtYmVkZGVkLWNvbnRlbnQtYXNzZXQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQ0FBc0MsR0FBRztJQUNwRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsZ0JBQWdCLEVBQUU7SUFDakMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUU7Z0JBQ1IsUUFBUTtnQkFDUixTQUFTO2dCQUNULGVBQWU7Z0JBQ2YsZUFBZTtnQkFDZixjQUFjO2dCQUNkLE1BQU07Z0JBQ04sT0FBTztnQkFDUCxlQUFlO2dCQUNmLE9BQU87Z0JBQ1AsWUFBWTtnQkFDWixtQkFBbUI7Z0JBQ25CLGNBQWM7Z0JBQ2QsaUJBQWlCO2dCQUNqQixjQUFjO2dCQUNkLGlCQUFpQjtnQkFDakIsYUFBYTtnQkFDYix1QkFBdUI7Z0JBQ3ZCLE1BQU07Z0JBQ04sT0FBTztnQkFDUCxNQUFNO2dCQUNOLGVBQWU7Z0JBQ2YsT0FBTztnQkFDUCxjQUFjO2FBQ2Y7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSx3QkFBd0I7Q0FDQyxDQUFBO0FBSTFCLE1BQU0sOEJBQThCLEdBQUcsQ0FBQyxJQUFrQixFQUF3QyxFQUFFO0lBQ3pHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw4Q0FBc0MsQ0FBQyxJQUFJLENBQUE7QUFDbEUsQ0FBQyxDQUFBO0FBRlksUUFBQSw4QkFBOEIsa0NBRTFDIn0=